// Mui
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

export const StyledPaper = styled("div")((props) => ({
  display: "flex",
  flexDirection: props.page === "yes" ? "column" : "row",
  height: props.page === "yes" ? "inherit" : "60px",
  alignItems: props.alignItems ?? "center",
  justifyContent: "space-between",
  transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  overflow: "hidden",
  position: "relative",
  boxShadow:
    "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px",
  borderRadius: "16px",
  padding: props.padding === "lr" ? "0 24px" : "24px",
  marginBottom: "24px",
}));

export const StyledButton = styled(Button)((props) => ({
  color: "#FFFFFF",
  backgroundColor: props.reset ? "#d32f2f" : "#0A9C75",
  borderRadius: "16px",
  width: "100%",
}));

export const StyledCard = styled("div")((props) => ({
  backgroundColor: "rgb(255, 255, 255)",
  color: "rgb(33, 43, 54)",
  minHeight: "60px",
  transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  overflow: "hidden",
  position: "relative",
  boxShadow:
    "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px",
  borderRadius: "16px",
  textAlign: "center",
  "&:hover": {
    cursor: props.noHover ? "inherit" : "pointer",
    boxShadow: props.noHover
      ? "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px"
      : "rgb(145 158 171 / 80%) 0px 0px 2px 0px, rgb(145 158 171 / 80%) 0px 12px 24px -4px",
  },
}));

export const StyledDetailCard = styled("div")((props) => ({
  backgroundColor: "rgb(255, 255, 255)",
  color: "rgb(33, 43, 54)",
  transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  backgroundImage: "none",
  overflow: "hidden",
  boxShadow:
    "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px",
  borderRadius: "16px",
  zIndex: 0,
  marginBottom: "24px",
  position: "relative",
}));

export const StyledBlogCard = styled("div")((props) => ({
  backgroundColor: "rgb(255, 255, 255)",
  color: "rgb(33, 43, 54)",
  transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  backgroundImage: "none",
  overflow: "hidden",
  position: "relative",
  boxShadow: "",
  borderRadius: "16px",
  zIndex: 0,
  "&:hover": {
    cursor: props.noHover ? "inherit" : "pointer",
    boxShadow: props.noHover
      ? "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px"
      : "rgb(145 158 171 / 80%) 0px 0px 2px 0px, rgb(145 158 171 / 80%) 0px 12px 24px -4px",
  },
}));
